import { request } from "../request";
const mock = "";
export const getMyCourseList = (params) =>
  request(`/v1/teacherCourse/getMyCourseList`, "get", {
    params,
  });

export const createLesson = (params) =>
  request(`${mock}/v1/seller/lesson/save`, "POST", {
    json: params,
  });

export const createUnit = (params) =>
  request(`${mock}/v1/seller/unit/save`, "POST", {
    json: params,
  });

export const checkLiveTime = (params) =>
  request(`/v1/seller/lesson/checkLiveTime`, "get", {
    params,
  });

// 获取职员列表
export const getStaffList = (params) =>
  request(`/v1/seller/course/teacher/list`, "get", {
    params,
  });
